export default {"src":"/_next/static/media/health.e92cc09e.svg","height":88,"width":88,"blurWidth":0,"blurHeight":0};